// Module
var code = "<supplier-product-groups supplier-id=\"vm.supplier.id\">\n</supplier-product-groups>\n";
// Exports
module.exports = code;